
import { Box, Button, Card, CardContent, Container, Dialog, DialogContent, DialogTitle, Divider, Fab, FormControl, FormHelperText, Grid, IconButton, InputLabel, MenuItem, Select, TableCell, TableRow, TextField, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { NON_TRANSPORTER_STOCK_TRANSFER } from '../../../common/URLs';
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { SubmitIcon } from '../../../common/icons';
import { ConfirmationPopover } from '../../../common/commonPopovers/confirmationPopover';
import { useNavigate } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import { KeyboardArrowLeftRounded } from '@mui/icons-material';
import BundleSelection from './nstrBundleSelection';
import axios from "axios";
import apiClient from '../../../axios';

export default function NSTRDetails() {
    const navigate = useNavigate();
    const { state } = useLocation();
    const selectedNSTR = state?.selectedNSTR;
    const [selectedHeap, setSelectedHeap] = useState([]);
    const [pickupQuantity, setPickupQuantity] = useState();
    // console.log("selectedHeap--main", selectedHeap)
    const [open, setOpen] = useState(false);
    const [response, setResponse] = useState();
    const [isApiCalled, setIsApiCalled] = useState(false);

    const handleSubmit = ({ heaps, pickupQty }) => {
        setSelectedHeap(heaps);
        setPickupQuantity(pickupQty);
    };


    const [confirmOpen2, setConfirmOpen2] = useState(false);
    const handleConfirmOpen2 = () => setConfirmOpen2(true);
    const handleConfirmClose2 = () => setConfirmOpen2(false);

    const onSubmit = (e) => {
        if (selectedHeap?.length === 0) {
            toast.error("Please select bundles for pick-up!")
        }
        else if (selectedNSTR?.stockTransferQuantity !== Number(pickupQuantity)) {
            toast.error("Stock Transfer Quantity and Pick-up Weight should be same!")
        }
        else handleConfirmOpen2();
    }

    // const onConfirmSubmit = (e) => {
    //     handleConfirmClose2();
    //     nonTransporterStockTransfer(e);
    // }

 
    const onConfirmSubmit = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await nonTransporterStockTransfer();
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setConfirmOpen2(false);
            setIsApiCalled(false);
        }
    };

    const nonTransporterStockTransfer = (e) => {
        let tempArr = selectedHeap?.map(item => ({
            inventoryId: item?.id,
            bundleId: item?.bundleId,
            weightTaken: item?.pickupQty
        }));
        loaderService.showLoader();
        apiClient
            .post(
                NON_TRANSPORTER_STOCK_TRANSFER,
                {
                    "stockTransferNumber": selectedNSTR?.stockTransferNumber,
                    "materialType": selectedNSTR?.materialType === "chipbamboo" ? "ChipBamboo" : selectedNSTR?.materialType === "rawbamboo" ? "RawBamboo" : "",
                    "sourceStakeholderType": selectedNSTR?.sourceStakeholderType,
                    "sourceStakeholderUrn": selectedNSTR?.sourceStakeholderUrn,
                    "destinationStakeholderType": selectedNSTR?.destinationStakeholderType,
                    "destinationStakeholderUrn": selectedNSTR?.destinationStakeholderUrn,
                    "isNonTransporterRequest": true,
                    "stockTransferInventories": tempArr

                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                }
            )
            .then((response) => {
                setResponse(response.data);
                setSelectedHeap([]);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log("axiosERROR", error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    useEffect(() => {
        if (response) {
            if (response.isSuccess === true) {
                toast.success(response?.message)
                navigate('/nonTransporterStockTransfer')
            }
            else {
                toast.error(response?.message ? response?.message : "Error")
            }
        }
    }, [response]);

    return (
        <>
            <Container maxWidth="xxl">
                <Typography variant="h4" gutterBottom>
                    <Fab onClick={() => { navigate(-1) }} size="small" aria-label="back" title='Back'>
                        <KeyboardArrowLeftRounded />
                    </Fab> Non Transporter Stock Transfer
                </Typography>
                <Card>
                    <CardContent>
                        <Grid container spacing={1} direction="row" mt={1}>
                            <Grid item xs={12}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label='Stock Transfer Number' type="text" disabled={true} value={selectedNSTR?.stockTransferNumber} />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label='Financial Year' type="text" disabled={true} value={selectedNSTR?.financialYear} />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label='Month' type="text" disabled={true} value={selectedNSTR?.month} />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label='Material Type' type="text" disabled={true} value={selectedNSTR?.materialType === "chipbamboo" ? "Chip Bamboo" : selectedNSTR?.materialType === "rawbamboo" ? "Raw Bamboo" : ""} />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label='Stock Transfer Quantity(MT)' type="number" disabled={true} value={selectedNSTR?.stockTransferQuantity} />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label='Source Type' type="text" disabled={true} value={selectedNSTR?.sourceStakeholderType} />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label='Source URN' type="text" disabled={true} value={selectedNSTR?.sourceStakeholderUrn} />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label='Source Name' type="text" disabled={true} value={selectedNSTR?.sourceStakeholderName} />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label='Source Address' type="text" disabled={true} value={selectedNSTR?.sourceStakeholderAddress} />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label='Destination Type' type="text" disabled={true} value={selectedNSTR?.destinationStakeholderType} />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label='Destination URN' type="text" disabled={true} value={selectedNSTR?.destinationStakeholderUrn} />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label='Destination Name' type="text" disabled={true} value={selectedNSTR?.destinationStakeholderName} />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label='Destination Address' type="text" disabled={true} value={selectedNSTR?.destinationStakeholderAddress} />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label='Pick-up Weight(MT)' type="number" disabled={true} value={pickupQuantity || ''} />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <Button onClick={() => setOpen(true)}>Select Bundle</Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <Box display='flex' justifyContent="flex-end" mt={2}>
                    <Button variant="contained" onClick={() => onSubmit()} endIcon={<SubmitIcon />}>Submit</Button>
                </Box>
            </Container>
            <ConfirmationPopover onOpen={confirmOpen2} onConfirm={onConfirmSubmit} onClose={handleConfirmClose2} action="Submit" />
            <BundleSelection open={open} selectedNSTR={selectedNSTR} pickupQuantity={pickupQuantity} setPickupQuantity={setPickupQuantity} onClose={() => setOpen(false)} onSubmit={handleSubmit} selectedHeap={selectedHeap} />
        </>
    );
}